import React from 'react';

const ChevronDown = () => (
  <svg
    width="11px"
    height="8px"
    viewBox="0 0 11 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon
        id="chevron_up"
        fill="#333333"
        points="9.61328125 7.1875 5.5 2.85839844 1.32324219 7.1875 0.0791015625 5.82910156 5.5 0.141601562 10.9208984 5.82910156"
      />
    </g>
  </svg>
);

export default ChevronDown;
